<!-- 
	This is the new product page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

 <template>
    <div>
  
     
       
        <div class="mb-50">
          <a-card :bordered="false" class="header-solid" :bodyStyle="{ paddingTop: 0 }"
            :headStyle="{ paddingBottom: '0' }">
  
  
  
            <a-form :form="form" :hideRequiredMark="true">
              <a-row :gutter="[24]">
                <a-col :span="24">
                  <a-form-item class="tags-field mb-10" label="First Component Name" :colon="false">
                    <a-select v-model="selectedTags1" style="width: 100%" placeholder="eg. UREA (46) BULK">
                      <a-select-option v-for="classification1 in classificationData1" :key="classification1.id"
                        :value="classification1.id">
                        {{ classification1.component_Name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>        
                
                <a-col :span="24">   
                  <a-form-item class="tags-field mb-10" label="Second Component Name" :colon="false">
                    <a-select v-model="selectedTags2" style="width: 100%" placeholder="eg. UREA (46) BULK">
                      <a-select-option v-for="classification2 in classificationData2" :key="classification2.id"
                        :value="classification2.id">
                        {{ classification2.component_Name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-button type="primary" @click="createRestrictedBlend()">Create</a-button>
                  </a-form-item>
                </a-col>              
              </a-row>
            </a-form>
  
            <template #title>
              <h5 class="mb-0">Restricted Blends Creation</h5>
            </template>
          </a-card>
        </div>
      </div>

  
  
  </template>
  
  <script>
  
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import { quillEditor } from 'vue-quill-editor'

  export default {
    components: {
      quillEditor,
    },
  
  
    data() {
      return {
        selectedTags1: "",
        selectedTags2: "",
        classificationData1: [],
        classificationData2: [], 
        form: this.$form.createForm(this, { name: 'newRestrictedBlend' })
      }
    },

    methods: {
      createRestrictedBlend(){
        if(this.selectedTags1 && this.selectedTags2)
        {
          let classificationArray = [{
            classificationId1: this.selectedTags1,
            classificationId2: this.selectedTags2
          }];

          this.$store.dispatch("restrictedBlends/addRestrictedBlend", classificationArray[0]).then(()=>{
            if(this.restrictedBlend.successInt == 1){
              this.$router.push('/RestrictedBlends/RestrictedBlends-list');
            }else{
              // add prompt for error
              console.log("an error has occurred");
              this.$router.push('/RestrictedBlends/RestrictedBlends-list');
            }
          });
        }
      }
    },
    computed: {
      classifications: {
        get() { 
          return this.$store.state.classifications.classifications;
        }
      },
      restrictedBlend: {
        get() { 
          return this.$store.state.restrictedBlends.restrictedBlend;
        }
      },
    },
    created() {
      this.$store.dispatch('classifications/getAll').then((res) => {
        this.classificationData1 = this.$store.state.classifications.classifications;
        this.classificationData2 = this.$store.state.classifications.classifications;
      }).catch(error => {
        console.error(error)
      })
    }
  }
  
  </script>
  
  <style lang="scss">
  .avatar {
    width: 50px;
    height: 50px;
    margin-top: 10px;
  }
  </style>